module.exports = __webpack_public_path__ + "img/dsrw.36aec7e4.png";